/**
 * Format raw messages object to certain degree
 * So we can display some data nicely
 */
export const formatMessage = senderUserId => {
  let prevSenderUserId = senderUserId | '';
  return message => {
    let data;
    try {
      data = JSON.parse(message.data);
      data.data =
        typeof data.data === 'string' ? JSON.parse(data.data) : data.data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to parse data JSON', JSON.stringify(message.data));
    }

    const formattedMessage = {
      ...message,
      prevSenderUserId,
      sender: message._sender,
      data: data || { metadata: {} }
    };

    // Save this user id as reference
    // for next iteration
    prevSenderUserId = message._sender.userId;
    return formattedMessage;
  };
};

/**
 * Convert data js object into a plain text
 * @param {Object} data object which want to be converted
 */
export const formatData = (
  { senderId, senderName, receiverId, language },
  data = null
) =>
  JSON.stringify({
    metadata: {
      senderType: 10,
      senderId,
      senderName,
      receiverId,
      language
    },
    data
  });
